"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchOutlined = void 0;
var react_1 = __importStar(require("react"));
var BaseIcon_1 = require("../icon/BaseIcon");
exports.SearchOutlined = (0, react_1.memo)(function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, className = _a.className, dataTestId = _a.dataTestId;
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, { className: className, dataTestId: dataTestId, size: size, title: title },
        size === 'large' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "M19.7434 20.5321C18.2306 21.7378 16.314 22.4583 14.2292 22.4583C9.33915 22.4583 5.375 18.4942 5.375 13.6042C5.375 8.71415 9.33915 4.75 14.2292 4.75C19.1192 4.75 23.0833 8.71415 23.0833 13.6042C23.0833 15.6888 22.3629 17.6051 21.1575 19.1178L27.3325 25.2928L25.9183 26.707L19.7434 20.5321ZM21.0833 13.6042C21.0833 17.3896 18.0146 20.4583 14.2292 20.4583C10.4437 20.4583 7.375 17.3896 7.375 13.6042C7.375 9.81872 10.4437 6.75 14.2292 6.75C18.0146 6.75 21.0833 9.81872 21.0833 13.6042Z", fillRule: "evenodd" })),
        size === 'medium' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "M16.1667 10.0833C16.1667 13.1669 13.6669 15.6667 10.5833 15.6667C7.49974 15.6667 5 13.1669 5 10.0833C5 6.99974 7.49974 4.5 10.5833 4.5C13.6669 4.5 16.1667 6.99974 16.1667 10.0833ZM15.0336 15.5945C13.8174 16.5778 12.2691 17.1667 10.5833 17.1667C6.67132 17.1667 3.5 13.9954 3.5 10.0833C3.5 6.17132 6.67132 3 10.5833 3C14.4954 3 17.6667 6.17132 17.6667 10.0833C17.6667 11.7692 17.0777 13.3176 16.0942 14.5338L21.0301 19.4696L19.9694 20.5303L15.0336 15.5945Z", fillRule: "evenodd" }))));
});
exports.SearchOutlined.displayName = 'SearchOutlined';
//# sourceMappingURL=SearchOutlined.js.map